import { AIReviewsSummary, Section, useConfig } from '@seek/libs-shared';
import { useMelwaysLink } from '@seek/melways-react';
import { useTranslations } from '@vocab/react';
import {
  Actions,
  ButtonLink,
  Card,
  IconArrow,
  Inline,
  Stack,
} from 'braid-design-system';
import { useParams, useSearchParams } from 'react-router';
import { CompanyProfilesPage, ROOT_PATH } from '../../../../paths';
import type { SalariesTabModel } from '../../../pages/salaries/salariesTabModel';
import translations from './.vocab/index';

interface CompanyReviewAISummarySectionProps {
  model: Pick<SalariesTabModel, 'companyReviewsAISummary' | 'companyName'>;
  onActiveTabChanged: (item: string | undefined) => void;
  trackReviewsClicked: () => void;
}

export const CompanyReviewAISummarySection = ({
  model,
  onActiveTabChanged,
  trackReviewsClicked,
}: CompanyReviewAISummarySectionProps) => {
  const { companyReviewsAISummary, companyName } = model;

  const { t } = useTranslations(translations);
  const { language } = useConfig();
  const urlParams = useParams();
  const [params] = useSearchParams();
  const localize = useMelwaysLink();

  const isDraftLink = params.get('draft') === 'true' ? '?draft=true' : '';

  const seeAllReviewsLink = localize({
    path: `/${ROOT_PATH}/${urlParams.companySlug}/${CompanyProfilesPage.Reviews}${isDraftLink}`,
    language,
  });

  return (
    <Section
      mode={'view'}
      heading={t('Working at companyName', { companyName })}
      padding={'none'}
    >
      <Stack space="medium">
        <Card>
          <AIReviewsSummary
            companyName={companyName}
            companyReviewsAISummary={companyReviewsAISummary}
            shouldDisplayHeading={false}
          />
        </Card>
        <Actions>
          <Inline space="none">
            <ButtonLink
              href={seeAllReviewsLink}
              onClick={() => {
                trackReviewsClicked();
                onActiveTabChanged('reviews');
              }}
              icon={<IconArrow direction="right" />}
              iconPosition="trailing"
            >
              {t('See all reviews')}
            </ButtonLink>
          </Inline>
        </Actions>
      </Stack>
    </Section>
  );
};
